import axios from "axios";

// Public endpoints (no login): the signed token in the email link is the authorisation.
// A plain axios instance on purpose — apiAxios adds the session token and redirects on 401.
const client = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/api/v1/erp`,
  timeout: 30000,
  headers: { "Content-Type": "application/json" },
});

export const fetchTestSign = (token) => client.get("/test_sign", { params: { token } }).then((r) => r.data);
export const submitTestSign = (token) => client.post("/test_sign", { token }).then((r) => r.data);
